import PathfindingVisualizer from 'pages/pathfinding/components/PathfindingVisualizer'
export default PathfindingVisualizer
